import request from './request'

// 获取设备列表
export function getPanelList (data) {
  return request.get('en/panel/list', data)
}
// 新增设备
export function addZone (data) {
  return request.post('en/zone/add', data)
}
// 修改
export function updateZone (data) {
  return request.post('en/zone/update', data)
}
// 删除
export function deleteZone (data) {
  return request.post('en/zone/delete', data)
}
// 详情
export function getPanelDetail (data) {
  return request.get('en/panel/getInfo', data)
}
// 设置系统
export function setResoundZoneInAlarm (data) {
  return request.post('en/panel/setResoundZoneInAlarm', data)
}
// 设置日立
export function setSchedule (data) {
  return request.post('en/panel/setSchedule', data, 'json')
}
// 查询历史记录
export function getAlarmList (data) {
  return request.get('en/alarm/list', data)
}
// 设置系统
export function setSystem (data) {
  return request.post('en/panel/setSystem', data, 'json')
}
// 新增控制器
export function addPanel (data) {
  return request.post('en/panel/add', data, 'json')
}
// 修改控制器
export function updatePanel (data) {
  return request.post('en/panel/update', data, 'json')
}
// 删除控制器
export function deletePanel (data) {
  return request.post('en/panel/delete', data)
}
// 设置控制器联网属性
export function setPanelNetworkInfo (data) {
  return request.post('en/panel/setPanelNetworkInfo', data, 'json')
}
// 设置控制器联网属性
export function setPanelIoCard (data) {
  return request.post('en//panel/setPanelIoCard', data, 'json')
}

